import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ConditionalWrapperComponent } from './conditional-wrapper.component';

const Components = [ConditionalWrapperComponent];
@NgModule({
  imports: [CommonModule],
  exports: Components,
  declarations: Components,
  providers: []
})
export class ConditionalWrapperModule {}
